import { WS_BASE_URL } from "../../../../environment";
import { WebSocketMessage } from "./chatTypes";

type MessageCallback = (message: WebSocketMessage) => void;

export class ChatWebSocketService {
    private ws: WebSocket | null = null;
    private tenantId: number | null = null;
    private userId: number | null = null;
    private messageCallbacks: MessageCallback[] = [];
    private reconnectAttempts = 0;
    private maxReconnectAttempts = 5;
    private reconnectDelay = 3000;
    private isIntentionallyClosed = false;
    private reconnectTimer: any = null;

    connect(tenantId: number, userId: number): void {
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }

        if (this.ws) {
            const wsToClose = this.ws;
            this.ws = null;
            wsToClose.onmessage = null;
            wsToClose.onerror = null;
            wsToClose.onclose = null;
            if (wsToClose.readyState === WebSocket.CONNECTING) {
                wsToClose.onopen = () => {
                    try {
                        wsToClose.close();
                    } catch (_) {}
                };
            } else {
                try {
                    wsToClose.close();
                } catch (_) {}
            }
        }
        
        this.tenantId = tenantId;
        this.userId = userId;
        this.isIntentionallyClosed = false;


        let wsUrl = `${WS_BASE_URL}/ws/external_chat/${tenantId}/${userId}`;



        if (wsUrl.startsWith("https://")) {
            wsUrl = wsUrl.replace("https://", "wss://");
        } else if (wsUrl.startsWith("http://")) {
            wsUrl = wsUrl.replace("http://", "ws://");
        }

        try {
            const currentWs = new WebSocket(wsUrl);
            this.ws = currentWs;

            this.ws.onopen = () => {

                this.reconnectAttempts = 0;
            };

            this.ws.onmessage = (event) => {
                try {
                    const message: WebSocketMessage = JSON.parse(event.data);


                    this.messageCallbacks.forEach((callback) => callback(message));
                } catch (error) {

                }
            };

            this.ws.onerror = (error) => {

            };

            this.ws.onclose = () => {
                if (this.ws !== currentWs) return;

                if (!this.isIntentionallyClosed && this.reconnectAttempts < this.maxReconnectAttempts) {
                    this.reconnectAttempts++;

                    this.reconnectTimer = setTimeout(() => {
                        if (this.tenantId && this.userId) {
                            this.connect(this.tenantId, this.userId);
                        }
                    }, this.reconnectDelay);
                }
            };
        } catch (error) {

        }
    }

    disconnect(): void {
        this.isIntentionallyClosed = true;

        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }

        if (this.ws) {
            const wsToClose = this.ws;
            this.ws = null;
            wsToClose.onmessage = null;
            wsToClose.onerror = null;
            wsToClose.onclose = null;
            if (wsToClose.readyState === WebSocket.CONNECTING) {
                wsToClose.onopen = () => {
                    try {
                        wsToClose.close();
                    } catch (_) {}
                };
            } else {
                try {
                    wsToClose.close();
                } catch (_) {}
            }
        }

        this.messageCallbacks = [];
        this.tenantId = null;
        this.userId = null;
        this.reconnectAttempts = 0;
    }

    /**
     * Register a callback for incoming messages
     */
    onMessage(callback: MessageCallback): void {
        this.messageCallbacks.push(callback);
    }

    /**
     * Remove a message callback
     */
    offMessage(callback: MessageCallback): void {
        this.messageCallbacks = this.messageCallbacks.filter((cb) => cb !== callback);
    }

    /**
     * Check if WebSocket is connected
     */
    isConnected(): boolean {
        return this.ws !== null && this.ws.readyState === WebSocket.OPEN;
    }
}


export const chatWebSocketService = new ChatWebSocketService();
